module.exports = __webpack_public_path__ + "img/mtc-thumb.81d4dddb.jpg";